import { HTMLAttributes } from "react";

export default function Prisma(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.28482 30.3966C8.91039 29.8029 8.90473 29.0466 9.27023 28.4471L23.032 5.87957C23.7975 4.62437 25.6457 4.73413 26.2589 6.07117L38.8309 33.4879C39.2973 34.5051 38.7604 35.702 37.6931 36.0239L18.1363 41.9222C17.3495 42.1594 16.5016 41.8414 16.0618 41.1439L9.28482 30.3966ZM24.6198 12.4781C24.7524 11.8143 25.6573 11.7185 25.9245 12.3401L34.5965 32.5134C34.7597 32.8932 34.5566 33.3312 34.1622 33.4495L20.65 37.5045C20.1533 37.6535 19.6775 37.2173 19.7796 36.7063L24.6198 12.4781Z"
        fill="black"
      />
    </svg>
  )
}
